"use client";

import React from "react";
export default function TheGrowthAuthority() {
  const marqueeText = "Veteran Owned & Operated • Local Expertise • 24/7 Emergency Response • Same Day Service • Free Estimates • ";
  const repeatedItems = Array(4).fill(marqueeText);
  return <section data-section-id="149913" id="why-choose-us" className="bg-background text-foreground py-12 overflow-hidden">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          animation: marquee-scroll 30s linear infinite;
        }
      `}</style>

      <div className="h-[80px] border-y border-primary flex items-center overflow-hidden relative shadow-lg !bg-[hsl(137,66%,31%)]">
        {}
        <div className="flex w-max animate-marquee-scroll items-center">
          {repeatedItems.map((text, i) => <div key={i} data-index={i} className="flex items-center whitespace-nowrap">
              <span className="font-serif font-bold text-xl px-8 uppercase tracking-tighter !text-[hsl(0,0%,100%)] md:text-2xl">VETERAN OWNED & OPERATED • LOCAL EXPERTISE • 24/7 EMERGENCY RESPONSE • SAME DAY SERVICE • FREE ESTIMATES •</span>
              <span className="text-primary/50 select-none" aria-hidden="true">
                
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}